export default function clean_formula(calc) {
    if (calc.startsWith(" + ")) {
        calc = calc.slice(3);
    }

    return calc;
}
